@for (rates of groupedRates; track rates; let i = $index) {
  <div class="table-wrapper">
    <div class="header">
      @if (rates?.airline) {
        <img
          alt=""
          class="company-icon"
          [src]="rates?.airlineCompanyIcon"
          (error)="onImageError($event)"
        />
      }
      @if (rates?.airline) {
        <span style="margin-left: 6px">{{ rates?.airline }}</span>
      }
      @if (rates?.commodity) {
        <span>{{ rates?.commodity }}</span>
      }
      <img
        src="/assets/media/icons/dot.svg"
        alt="dot"
        style="margin-left: 10px; margin-right: 10px"
      />
      <span>{{ rates.origin }}</span>
      <img
        src="/assets/media/icons/route-flight.svg"
        alt="flight"
        style="margin-left: 10px; margin-right: 10px"
      />
      <span>{{ rates.destination }}</span>
    </div>
    <div class="d-flex main-container">
      <div class="table-res kt-container">
        <div class="dummy-wrapper" style="height: 30px"></div>
        <div>
          <mat-table [dataSource]="rates.dataSource" class="table-editable">
            <ng-container matColumnDef="airline">
              <mat-header-cell
                *matHeaderCellDef
                (click)="sortData('airlineBrandCode')"
                i18n="@@group-table.airline"
                class="airline-cell"
                >Airline
                <div class="sort-wrapper">
                  <span
                    class="sort-arrow-before"
                    [class.hide]="showSortIndicator('airlineBrandCode', 'asc')"
                  ></span>
                  <span
                    class="sort-arrow-after"
                    [class.hide]="showSortIndicator('airlineBrandCode', 'desc')"
                  ></span>
                </div>
              </mat-header-cell>
              <mat-cell
                *matCellDef="let row; let id = index"
                [matTooltip]="row.airlineCompanyName"
                class="airline-cell"
              >
                @if (row.airlineCompanyIcon) {
                  <span>
                    <img
                      alt=""
                      class="company-icon"
                      [src]="row.airlineCompanyIcon"
                      (error)="onImageError($event)"
                    />
                  </span>
                }
                {{ row.airlineCompanyCode }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="airlineProdCode">
              <mat-header-cell
                *matHeaderCellDef
                (click)="sortData('airlineProdCode')"
                class="expand"
                i18n="@@group-table.airline-prod-code"
                >Airline Product
                <div class="sort-wrapper">
                  <span
                    class="sort-arrow-before"
                    [class.hide]="showSortIndicator('airlineProdCode', 'asc')"
                  ></span>
                  <span
                    class="sort-arrow-after"
                    [class.hide]="showSortIndicator('airlineProdCode', 'desc')"
                  ></span>
                </div>
              </mat-header-cell>
              <mat-cell
                *matCellDef="let row; let id = index"
                [matTooltip]="tipsAirlineProdCode(row)"
                [ngStyle]="getColor('airlineProdCode', row)"
                class="expand"
              >
                <div>
                  {{ renderAirlineProdCode(row) || "-" }}
                </div>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="commodity">
              <mat-header-cell
                *matHeaderCellDef
                (click)="sortData('commodityName')"
                class="expand"
                i18n="@@compare-rates.commodity"
                >Commodity
                <div class="sort-wrapper">
                  <span
                    class="sort-arrow-before"
                    [class.hide]="showSortIndicator('commodityName', 'asc')"
                  ></span>
                  <span
                    class="sort-arrow-after"
                    [class.hide]="showSortIndicator('commodityName', 'desc')"
                  ></span>
                </div>
              </mat-header-cell>
              <mat-cell
                *matCellDef="let row"
                [matTooltip]="tipsCommodity(row)"
                class="expand"
              >
                <div>
                  {{ row.commodity || "-" }}
                </div>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="M">
              <mat-header-cell
                *matHeaderCellDef
                (click)="sortData('minAmt')"
                i18n="@@group-table.min"
                class="amount-header-cell"
                >Min
                <div class="sort-wrapper">
                  <span
                    class="sort-arrow-before"
                    [class.hide]="showSortIndicator('minAmt', 'asc')"
                  ></span>
                  <span
                    class="sort-arrow-after"
                    [class.hide]="showSortIndicator('minAmt', 'desc')"
                  ></span></div
              ></mat-header-cell>
              <mat-cell
                *matCellDef="let row; let id = index"
                class="amount-cell"
              >
                <div class="d-flex flex-column align-items-end">
                  <span
                    class="selling-rate"
                    [class.marked-up]="
                      row.M_original && row.M !== row.M_original
                    "
                  >
                    {{ formatMoney(row.M, row.currency) || "-" }}
                  </span>
                  @if (showBuyingRate && row.M_original) {
                    <span class="buying-rate">
                      BR {{ formatMoney(row.M_original, row.currency) || "-" }}
                    </span>
                  }
                </div>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="rateType">
              <mat-header-cell
                *matHeaderCellDef
                (click)="sortData('type')"
                class="type-cell"
                i18n="@@compare-rates.rate-type"
                >Rate Type
                <div class="sort-wrapper">
                  <span
                    class="sort-arrow-before"
                    [class.hide]="showSortIndicator('type', 'asc')"
                  ></span>
                  <span
                    class="sort-arrow-after"
                    [class.hide]="showSortIndicator('type', 'desc')"
                  ></span>
                </div>
              </mat-header-cell>
              <mat-cell *matCellDef="let row; let id = index" class="type-cell">
                <div [ngClass]="rateClass(row.type)" class="rate-type">
                  {{ displayRateType(getRateType(row)) || "-" }}
                </div>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="currency">
              <mat-header-cell
                *matHeaderCellDef
                i18n="@@group-table.currency"
                class="currency-cell"
                (click)="sortData('currency')"
              >
                CCY
                <div class="sort-wrapper">
                  <span
                    class="sort-arrow-before"
                    [class.hide]="showSortIndicator('currency', 'asc')"
                  ></span>
                  <span
                    class="sort-arrow-after"
                    [class.hide]="showSortIndicator('currency', 'desc')"
                  ></span>
                </div>
              </mat-header-cell>
              <mat-cell
                class="currency-cell"
                *matCellDef="let row; let id = index"
              >
                {{ row.currency || "-" }}</mat-cell
              >
            </ng-container>
            <mat-header-row
              *matHeaderRowDef="displayedColumns; sticky: true"
            ></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"> </mat-row>
          </mat-table>
        </div>
      </div>
      <div class="table-res kt-container table-2">
        <div>
          <div class="tab-wrapper">
            <div
              class="tabs weight"
              [class.active]="tabSelected[i] === 'weight'"
              (click)="onTabChange(i, 'weight')"
            >
              Weight Breaks & Surcharges
            </div>
            <div
              class="tabs flight"
              [class.active]="tabSelected[i] === 'flight'"
              (click)="onTabChange(i, 'flight')"
            >
              Flight & Cargo
            </div>
            <div
              class="tabs rate"
              [class.active]="tabSelected[i] === 'rate'"
              (click)="onTabChange(i, 'rate')"
            >
              Rate Details
            </div>
            <div
              class="tabs support"
              [class.active]="tabSelected[i] === 'support'"
              (click)="onTabChange(i, 'support')"
            >
              Support
            </div>
          </div>
          <div>
            <mat-table [dataSource]="rates.dataSource" class="table-editable">
              <ng-container matColumnDef="N">
                <mat-header-cell
                  *matHeaderCellDef
                  (click)="sortData('nomPivotWt')"
                  i18n="@@group-table.nom"
                  class="rate-cell"
                  >Nom
                  <div class="sort-wrapper">
                    <span
                      class="sort-arrow-before"
                      [class.hide]="showSortIndicator('nomPivotWt', 'asc')"
                    ></span>
                    <span
                      class="sort-arrow-after"
                      [class.hide]="showSortIndicator('nomPivotWt', 'desc')"
                    ></span></div
                ></mat-header-cell>
                <mat-cell
                  *matCellDef="let row; let id = index"
                  [ngClass]="getClassForText(row.N, row)"
                >
                  <div class="d-flex flex-column align-items-end">
                    <span
                      class="selling-rate"
                      [class.marked-up]="
                        row.N_original && row.N !== row.N_original
                      "
                    >
                      {{ formatMoney(row.N, row.currency) || "-" }}
                    </span>
                    @if (showBuyingRate && row.N_original) {
                      <span class="buying-rate">
                        BR
                        {{ formatMoney(row.N_original, row.currency) || "-" }}
                      </span>
                    }
                  </div>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="kg45">
                <mat-header-cell
                  *matHeaderCellDef
                  (click)="sortData('wbxlvOver')"
                  class="rate-cell"
                >
                  45KG
                  <div class="sort-wrapper">
                    <span
                      class="sort-arrow-before"
                      [class.hide]="showSortIndicator('wbxlvOver', 'asc')"
                    ></span>
                    <span
                      class="sort-arrow-after"
                      [class.hide]="showSortIndicator('wbxlvOver', 'desc')"
                    ></span>
                  </div>
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row; let id = index"
                  [ngClass]="getClassForText(row.kg45, row)"
                >
                  <div class="d-flex flex-column align-items-end">
                    <span
                      class="selling-rate"
                      [class.marked-up]="
                        row.kg45_original && row.kg45 !== row.kg45_original
                      "
                    >
                      {{ formatMoney(row.kg45, row.currency) || "-" }}
                    </span>
                    @if (showBuyingRate && row.kg45_original) {
                      <span class="buying-rate">
                        BR
                        {{
                          formatMoney(row.kg45_original, row.currency) || "-"
                        }}
                      </span>
                    }
                  </div>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="kg100">
                <mat-header-cell
                  *matHeaderCellDef
                  (click)="sortData('wbcMaxWt')"
                  class="rate-cell"
                >
                  100KG
                  <div class="sort-wrapper">
                    <span
                      class="sort-arrow-before"
                      [class.hide]="showSortIndicator('wbcMaxWt', 'asc')"
                    ></span>
                    <span
                      class="sort-arrow-after"
                      [class.hide]="showSortIndicator('wbcMaxWt', 'desc')"
                    ></span>
                  </div>
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row; let id = index"
                  [ngClass]="getClassForText(row.kg100, row)"
                >
                  <div class="d-flex flex-column align-items-end">
                    <span
                      class="selling-rate"
                      [class.marked-up]="
                        row.kg100_original && row.kg100 !== row.kg100_original
                      "
                    >
                      {{ formatMoney(row.kg100, row.currency) || "-" }}
                    </span>
                    @if (showBuyingRate && row.kg100_original) {
                      <span class="buying-rate">
                        BR
                        {{
                          formatMoney(row.kg100_original, row.currency) || "-"
                        }}
                      </span>
                    }
                  </div>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="kg300">
                <mat-header-cell
                  *matHeaderCellDef
                  (click)="sortData('wbccc')"
                  class="rate-cell"
                >
                  300KG
                  <div class="sort-wrapper">
                    <span
                      class="sort-arrow-before"
                      [class.hide]="showSortIndicator('wbccc', 'asc')"
                    ></span>
                    <span
                      class="sort-arrow-after"
                      [class.hide]="showSortIndicator('wbccc', 'desc')"
                    ></span>
                  </div>
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row; let id = index"
                  [ngClass]="getClassForText(row.kg300, row)"
                >
                  <div class="d-flex flex-column align-items-end">
                    <span
                      class="selling-rate"
                      [class.marked-up]="
                        row.kg300_original && row.kg300 !== row.kg300_original
                      "
                    >
                      {{ formatMoney(row.kg300, row.currency) || "-" }}
                    </span>
                    @if (showBuyingRate && row.kg300_original) {
                      <span class="buying-rate">
                        BR
                        {{
                          formatMoney(row.kg300_original, row.currency) || "-"
                        }}
                      </span>
                    }
                  </div>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="kg500">
                <mat-header-cell
                  *matHeaderCellDef
                  (click)="sortData('wbd')"
                  class="rate-cell"
                >
                  500KG
                  <div class="sort-wrapper">
                    <span
                      class="sort-arrow-before"
                      [class.hide]="showSortIndicator('wbd', 'asc')"
                    ></span>
                    <span
                      class="sort-arrow-after"
                      [class.hide]="showSortIndicator('wbd', 'desc')"
                    ></span>
                  </div>
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row; let id = index"
                  [ngClass]="getClassForText(row.kg500, row)"
                >
                  <div class="d-flex flex-column align-items-end">
                    <span
                      class="selling-rate"
                      [class.marked-up]="
                        row.kg500_original && row.kg500 !== row.kg500_original
                      "
                    >
                      {{ formatMoney(row.kg500, row.currency) || "-" }}
                    </span>
                    @if (showBuyingRate && row.kg500_original) {
                      <span class="buying-rate">
                        BR
                        {{
                          formatMoney(row.kg500_original, row.currency) || "-"
                        }}
                      </span>
                    }
                  </div>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="kg1000">
                <mat-header-cell
                  *matHeaderCellDef
                  (click)="sortData('wbm')"
                  class="rate-cell"
                >
                  1000KG
                  <div class="sort-wrapper">
                    <span
                      class="sort-arrow-before"
                      [class.hide]="showSortIndicator('wbm', 'asc')"
                    ></span>
                    <span
                      class="sort-arrow-after"
                      [class.hide]="showSortIndicator('wbm', 'desc')"
                    ></span>
                  </div>
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row; let id = index"
                  [ngClass]="getClassForText(row.kg1000, row)"
                >
                  <div class="d-flex flex-column align-items-end">
                    <span
                      class="selling-rate"
                      [class.marked-up]="
                        row.kg1000_original &&
                        row.kg1000 !== row.kg1000_original
                      "
                    >
                      {{ formatMoney(row.kg1000, row.currency) || "-" }}
                    </span>
                    @if (showBuyingRate && row.kg1000_original) {
                      <span class="buying-rate">
                        BR
                        {{
                          formatMoney(row.kg1000_original, row.currency) || "-"
                        }}
                      </span>
                    }
                  </div>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="kg3000">
                <mat-header-cell
                  *matHeaderCellDef
                  (click)="sortData('wbmmm')"
                  class="rate-cell"
                >
                  3000KG
                  <div class="sort-wrapper">
                    <span
                      class="sort-arrow-before"
                      [class.hide]="showSortIndicator('wbmmm', 'asc')"
                    ></span>
                    <span
                      class="sort-arrow-after"
                      [class.hide]="showSortIndicator('wbmmm', 'desc')"
                    ></span>
                  </div>
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row; let id = index"
                  [ngClass]="getClassForText(row.kg3000, row)"
                >
                  <div class="d-flex flex-column align-items-end">
                    <span
                      class="selling-rate"
                      [class.marked-up]="
                        row.kg3000_original &&
                        row.kg3000 !== row.kg3000_original
                      "
                    >
                      {{ formatMoney(row.kg3000, row.currency) || "-" }}
                    </span>
                    @if (showBuyingRate && row.kg3000_original) {
                      <span class="buying-rate">
                        BR
                        {{
                          formatMoney(row.kg3000_original, row.currency) || "-"
                        }}
                      </span>
                    }
                  </div>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="fuelSurcharge">
                <mat-header-cell
                  *matHeaderCellDef
                  (click)="sortData('fuelSurcharge')"
                  class="rate-cell"
                  i18n="@@group-table.fuel"
                >
                  FSC
                  <div class="sort-wrapper">
                    <span
                      class="sort-arrow-before"
                      [class.hide]="showSortIndicator('fuelSurcharge', 'asc')"
                    ></span>
                    <span
                      class="sort-arrow-after"
                      [class.hide]="showSortIndicator('fuelSurcharge', 'desc')"
                    ></span>
                  </div>
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row; let id = index"
                  [ngClass]="getClassForText(row.fuelSurcharge, row)"
                >
                  <div>
                    {{ formatSurcharge(row.fuelSurcharge, row.currency) }}
                  </div>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="securitySurcharge">
                <mat-header-cell
                  *matHeaderCellDef
                  (click)="sortData('securitySurcharge')"
                  class="rate-cell"
                  i18n="@@group-table.sec"
                >
                  IRC
                  <div class="sort-wrapper">
                    <span
                      class="sort-arrow-before"
                      [class.hide]="
                        showSortIndicator('securitySurcharge', 'asc')
                      "
                    ></span>
                    <span
                      class="sort-arrow-after"
                      [class.hide]="
                        showSortIndicator('securitySurcharge', 'desc')
                      "
                    ></span>
                  </div>
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row; let id = index"
                  [ngClass]="getClassForText(row.securitySurcharge, row)"
                >
                  <div>
                    {{ formatSurcharge(row.securitySurcharge, row.currency) }}
                  </div>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="miscellaneousCharge">
                <mat-header-cell
                  *matHeaderCellDef
                  (click)="sortData('miscellaneousCharge')"
                  class="rate-cell"
                  i18n="@@group-table.rate-feeder-service"
                >
                  RFS
                  <div class="sort-wrapper">
                    <span
                      class="sort-arrow-before"
                      [class.hide]="
                        showSortIndicator('miscellaneousCharge', 'asc')
                      "
                    ></span>
                    <span
                      class="sort-arrow-after"
                      [class.hide]="
                        showSortIndicator('miscellaneousCharge', 'desc')
                      "
                    ></span>
                  </div>
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row; let id = index"
                  [ngClass]="getClassForText(row.miscellaneousCharge, row)"
                  [matTooltip]="tipsRfs(row)"
                >
                  <div>
                    {{ formatSurcharge(row.miscellaneousCharge, row.currency) }}
                  </div>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="saf">
                <mat-header-cell
                  *matHeaderCellDef
                  (click)="sortData('saf')"
                  class="rate-cell"
                  i18n="@@group-table.saf"
                >
                  SAF
                  <div class="sort-wrapper">
                    <span
                      class="sort-arrow-before"
                      [class.hide]="showSortIndicator('saf', 'asc')"
                    ></span>
                    <span
                      class="sort-arrow-after"
                      [class.hide]="showSortIndicator('saf', 'desc')"
                    ></span>
                  </div>
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row; let id = index"
                  [ngClass]="getClassForText(row.saf, row)"
                >
                  <div>
                    {{ formatMoney(row.saf, row.currency) }}
                  </div>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="flightNo">
                <mat-header-cell
                  *matHeaderCellDef
                  (click)="sortData('flightNo')"
                  class="airline-cell"
                  i18n="@@group-table.flight-no"
                >
                  Flight No.
                  <div class="sort-wrapper">
                    <span
                      class="sort-arrow-before"
                      [class.hide]="showSortIndicator('flightNo', 'asc')"
                    ></span>
                    <span
                      class="sort-arrow-after"
                      [class.hide]="showSortIndicator('flightNo', 'desc')"
                    ></span>
                  </div>
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row; let id = index"
                  class="airline-cell"
                >
                  <div>
                    {{ row.flightNo || "-" }}
                  </div>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="aircraftTypes">
                <mat-header-cell
                  *matHeaderCellDef
                  (click)="sortData('aircraftTypes')"
                  class="service-cell"
                  i18n="@@compare-rates.aircraft-types"
                  >Aircraft Types
                  <div class="sort-wrapper">
                    <span
                      class="sort-arrow-before"
                      [class.hide]="showSortIndicator('aircraftTypes', 'asc')"
                    ></span>
                    <span
                      class="sort-arrow-after"
                      [class.hide]="showSortIndicator('aircraftTypes', 'desc')"
                    ></span>
                  </div>
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row; let id = index"
                  class="service-cell"
                >
                  <div>
                    {{ displayAircraftTypes(row.aircraftTypes) }}
                  </div>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="shcs">
                <mat-header-cell
                  *matHeaderCellDef
                  (click)="sortData('shcs')"
                  class="service-cell"
                  i18n="@@group-table.SHC"
                  >SHC
                  <div class="sort-wrapper">
                    <span
                      class="sort-arrow-before"
                      [class.hide]="showSortIndicator('shcs', 'asc')"
                    ></span>
                    <span
                      class="sort-arrow-after"
                      [class.hide]="showSortIndicator('shcs', 'desc')"
                    ></span>
                  </div>
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row; let id = index"
                  class="service-cell"
                >
                  <div>
                    {{ row.shcs || "-" }}
                  </div>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="density">
                <mat-header-cell
                  *matHeaderCellDef
                  (click)="sortData('density')"
                  class="airline-cell"
                  i18n="@@compare-rates.density"
                >
                  Density
                  <div class="sort-wrapper">
                    <span
                      class="sort-arrow-before"
                      [class.hide]="showSortIndicator('density', 'asc')"
                    ></span>
                    <span
                      class="sort-arrow-after"
                      [class.hide]="showSortIndicator('density', 'desc')"
                    ></span>
                  </div>
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row; let id = index"
                  class="airline-cell"
                >
                  <div>
                    {{ row.density || "-" }}
                  </div>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="startDate">
                <mat-header-cell
                  *matHeaderCellDef
                  (click)="sortData('startDate')"
                  i18n="@@compare-rates.start-date"
                  class="date-cell-l"
                >
                  Start
                  <div class="sort-wrapper">
                    <span
                      class="sort-arrow-before"
                      [class.hide]="showSortIndicator('startDate', 'asc')"
                    ></span>
                    <span
                      class="sort-arrow-after"
                      [class.hide]="showSortIndicator('startDate', 'desc')"
                    ></span>
                  </div>
                </mat-header-cell>
                <mat-cell
                  class="date-cell-l"
                  *matCellDef="let row; let id = index"
                  [matTooltip]="formatDate(row.startDate, 'MMM yyyy')"
                >
                  {{ formatDate(row.startDate, "dd MMM") || "-" }}</mat-cell
                >
              </ng-container>
              <ng-container matColumnDef="endDate">
                <mat-header-cell
                  *matHeaderCellDef
                  (click)="sortData('endDate')"
                  i18n="@@group-table.end-date"
                  class="date-cell-r"
                >
                  End
                  <div class="sort-wrapper">
                    <span
                      class="sort-arrow-before"
                      [class.hide]="showSortIndicator('endDate', 'asc')"
                    ></span>
                    <span
                      class="sort-arrow-after"
                      [class.hide]="showSortIndicator('endDate', 'desc')"
                    ></span>
                  </div>
                </mat-header-cell>
                <mat-cell
                  class="date-cell-r"
                  *matCellDef="let row; let id = index"
                  [matTooltip]="formatEndDate(row.endDate, 'MMM yyyy', true)"
                >
                  {{ formatEndDate(row.endDate, "dd MMM") || "-" }}</mat-cell
                >
              </ng-container>
              <ng-container matColumnDef="freightAmount">
                <mat-header-cell *matHeaderCellDef class="amount-cell">
                  Freight
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row; let id = index"
                  class="amount-cell"
                  [class.marked-up]="
                    row.originalFreightAmount &&
                    row.freightAmount !== row.originalFreightAmount
                  "
                >
                  {{ formatMoney(row.freightAmount, row.currency) }}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="freightSurcharge">
                <mat-header-cell *matHeaderCellDef class="amount-cell">
                  Surcharges
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row; let id = index"
                  class="amount-cell"
                >
                  {{ formatSurcharge(row.freightSurcharge, row.currency) }}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="freightTotal">
                <mat-header-cell *matHeaderCellDef class="amount-cell">
                  Total Charges
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row; let id = index"
                  class="amount-cell"
                  [class.marked-up]="
                    row.originalFreightTotal &&
                    row.freightTotal !== row.originalFreightTotal
                  "
                >
                  {{ formatMoney(row.freightTotal, row.currency) }}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="day">
                <mat-header-cell
                  *matHeaderCellDef
                  (click)="sortData('day')"
                  class="number-cell"
                  i18n="@@compare-rates.day"
                >
                  Day
                  <div class="sort-wrapper">
                    <span
                      class="sort-arrow-before"
                      [class.hide]="showSortIndicator('day', 'asc')"
                    ></span>
                    <span
                      class="sort-arrow-after"
                      [class.hide]="showSortIndicator('day', 'desc')"
                    ></span>
                  </div>
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row; let id = index"
                  class="number-cell"
                  [matTooltip]="row.forwarderOfficeName"
                >
                  <div>
                    {{ row.day || "-" }}
                  </div>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="lastUpdatedDate">
                <mat-header-cell
                  *matHeaderCellDef
                  i18n="@@compare-rate-forwarder.Last-updated"
                  class="time-cell"
                >
                  Last Updated
                </mat-header-cell>
                <mat-cell
                  class="time-cell-m"
                  *matCellDef="let row; let id = index"
                  [matTooltip]="formatDate(row.lastUpdatedDate, 'MMM yyyy')"
                >
                  {{
                    formatDate(row.lastUpdatedDate, "dd MMM HH:mm") || "-"
                  }}</mat-cell
                >
              </ng-container>
              <ng-container matColumnDef="GHA Contact">
                <mat-header-cell
                  *matHeaderCellDef
                  i18n="@@compare-rate-forwarder.gha-contact"
                  class="airline-cell"
                >
                  GHA Contact
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row; let id = index"
                  class="airline-cell"
                >
                  <img
                    alt="gha-contact"
                    class="contact-icon"
                    [class.disabled]="!row.ghaContactInfo"
                    [src]="
                      row.ghaContactInfo
                        ? '/assets/media/icons/compare-rate/gha.png'
                        : '/assets/media/icons/compare-rate/gha-disabled.png'
                    "
                    [matTooltip]="'GHA contact'"
                    (click)="displayGHAContact(row)"
                /></mat-cell>
              </ng-container>
              <ng-container matColumnDef="Airline Contact">
                <mat-header-cell
                  *matHeaderCellDef
                  i18n="@@compare-rate-forwarder.airline-contact"
                  class="airline-cell"
                >
                  Airline Contact
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row; let id = index"
                  class="airline-cell"
                >
                  <img
                    alt="airline-contact"
                    class="contact-icon"
                    [class.disabled]="
                      !row.airlineUserContactInfo ||
                      row.airlineUserContactInfo.length < 1
                    "
                    [src]="
                      row.airlineUserContactInfo &&
                      row.airlineUserContactInfo.length > 0
                        ? '/assets/media/icons/compare-rate/airline-contact.png'
                        : '/assets/media/icons/compare-rate/airline-contact-disabled.png'
                    "
                    [matTooltip]="'Airline contact'"
                    (click)="displayAirlineContact(row)"
                /></mat-cell>
              </ng-container>
              <ng-container matColumnDef="Airline Schedule">
                <mat-header-cell
                  *matHeaderCellDef
                  i18n="@@compare-rate-forwarder.airline-schedule"
                  class="airline-cell"
                >
                  Airline Schedule
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row; let id = index"
                  class="airline-cell"
                >
                  <img
                    alt="airline-schedule"
                    class="contact-icon"
                    [class.disabled-color]="
                      row?.airlineBrand?.scheduleAttachments?.length < 1 &&
                      !row?.airlineBrand?.scheduleUrl
                    "
                    src="/assets/media/icons/compare-rate/airline-schedule.png
                  "
                    [matTooltip]="'Airline schedule'"
                    (click)="displayAirlineSchedule(row)"
                /></mat-cell>
              </ng-container>
              <ng-container matColumnDef="T&Cs">
                <mat-header-cell
                  *matHeaderCellDef
                  i18n="@@compare-rate-forwarder.t&cs"
                  class="airline-cell"
                >
                  T&Cs
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row; let id = index"
                  class="airline-cell"
                >
                  <img
                    alt="airline-information"
                    class="contact-icon"
                    [src]="
                      '/assets/media/icons/compare-rate/airline-general-information.png'
                    "
                    [matTooltip]="'Airline general information'"
                    (click)="displayAirlineGeneralInformation(row)"
                /></mat-cell>
              </ng-container>
              <mat-header-row
                *matHeaderRowDef="dynamicDisplayedColumns[i]; sticky: true"
              ></mat-header-row>
              <mat-row
                *matRowDef="let row; columns: dynamicDisplayedColumns[i]"
              >
              </mat-row>
            </mat-table>
          </div>
        </div>
      </div>
    </div>
  </div>
}
